<template>
  <slice
    v-if="productDocument.rating_average && productDocument.rating_number"
    :id="block._key"
    class="block-testimonial-note container"
    @in="$emit('in')"
    @out="$emit('out')"
  >
    <div
      class="inner d-flex flex-direction-column align-center mb-2"
      :class="{
        disabled: !$i18n.locale.startsWith('fr'),
      }"
      @click="handleNoteClick"
    >
      <p class="global-note text-secondary lh-1 mb-0-4 d-inline-flex">
        {{ productDocument.rating_average }}/5
      </p>

      <stars :value="productDocument.rating_average" />
    </div>

    <p class="block__text text-small text-center pl-2 pr-2">
      {{
        $t('testimonial.explain_note', {
          number: productDocument.rating_number,
        })
      }}
    </p>
  </slice>
</template>

<script>
import Slice from '@/components/Slices/Slice'
import Stars from '@/components/stars/Stars'
import { EVENTS } from '~/const/events'

export default {
  title: 'BlockTestimonialNote',
  components: { Slice, Stars },
  props: {
    block: { type: Object, required: true },
    productDocument: { type: Object, required: true },
  },
  methods: {
    handleNoteClick() {
      this.$nuxt.$emit(EVENTS.OPEN_TESTIMONIAL_MODAL)
    },
  },
}
</script>

<style lang="scss">
.block-testimonial-note {
  padding: calc(var(--spacing) * 2) 0 calc(var(--spacing) * 2);

  @include mq($from: tablet) {
    padding: calc(var(--spacing) * 4) 0 calc(var(--spacing) * 4);
  }

  .inner {
    &:not(.disabled) {
      cursor: pointer;
    }

    &.disabled {
      pointer-events: none;
    }
  }

  .global-note {
    font-size: rem(90px);
  }

  .star {
    width: rem(20px);
    height: rem(20px);
  }

  .block__text {
    max-width: rem(380px);
    margin: 0 auto;
  }
}
</style>
